// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/chevron-down-solid.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common element style */
.APO-booking a:hover{
    text-decoration: none!important;
}
.APO-booking .svg-inline--fa {
    display: inline-block;
    height: 1em;
    overflow: visible;

}
.silver__font {
    color: #717b81;
}
.APO-customSelect {
    position: relative!important;
}
.APO-customSelect .APO-customSelect__input {
    border-color: #e0eaf9 !important;
    height: 36px !important;
    margin-top: 0!important;
    position: relative!important;
    z-index: 10!important;
    padding: 0 0.75rem!important;
    font-size: 1rem!important;
    color: #212121!important;
    display: block!important;
    width: 100%!important;
    border-width: 0 0 1px!important;
    border-style: solid!important;
    border-radius: 0!important;
    font-family: inherit!important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none!important;
}

.APO-customSelect .APO-customSelect__dropdown {
    overflow-y: auto!important;
    max-height: 180px!important;
    border-color: #e0eaf9 !important;
    z-index: 10!important;
    top: calc(100% - 1px);
    background-color: #fff;
    border-width: 1px!important;
    border-style: solid!important;
    border-radius: 0 0 12px 12px!important;
    position: absolute;
    width: 100%;
    left: 0;
}
.APO-customSelect--dropup .APO-customSelect__dropdown {
    border-radius: 12px 12px 0 0!important;
    bottom: calc(100% - 1px);
    top: auto;
}
.APO-customSelect .APO-customSelect__option-wrap .APO-customSelect__option {
    border: none!important;
}
.APO-customSelect .APO-customSelect__option-wrap {
    overflow-y: auto!important;
    max-height: 180px!important;
    position: relative!important;
}
.APO-customSelect .APO-customSelect__option {
    font-family: inherit !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    height: 43px !important;
    border-radius: 12px !important;
    padding: 6px 12px !important;
    color: #212121 !important;
    line-height: 1.5 !important;
    background-color: #fff !important;
    border: 1px solid #e0eaf9 !important;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    display: block;
    width: 100%;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    cursor: pointer;
    user-select: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.APO-customSelect--active .APO-customSelect__option--value {
    border-radius: 12px 0 0px 0px !important;
}
.APO-customSelect--dropup.APO-customSelect--active .APO-customSelect__option--value {
    border-radius: 0 0 0px 12px!important;
}
.APO-customSelect .APO-customSelect__dropdown::-webkit-scrollbar, .APO-customSelect .APO-customSelect__dropdown .APO-customSelect__option-wrap::-webkit-scrollbar {
    display: none;
}
.APO-booking .APO-rounded-e-none .APO-customSelect .APO-customSelect__option {
    border-start-end-radius: 0px !important;
    border-end-end-radius: 0px !important;
}
.APO-booking .APO-border-r-0 .APO-customSelect .APO-customSelect__option {
    border-right-width: 0px!important;
}
.inputGroup .APO-customSelect .APO-customSelect__option { 
    width: 80px!important;
}
/* .APO-customSelect__option-wrap .APO-customSelect__option {
    padding: 6px 12px !important;
    border: none !important;
} */

/* Chrome, Safari, Edge, Opera */
input.input-field::-webkit-outer-spin-button,
input.input-field::-webkit-inner-spin-button {
  -webkit-appearance: none!important;
  margin: 0!important;
}

 /* Firefox */
input[type="number"].input-field{
    -webkit-appearance: textfield!important;
    -moz-appearance: textfield!important;
    appearance: textfield!important;
}
.input-field:focus-visible {
    outline: none!important;
}
.has-error, .no-data {
    color: #dc3545 !important;
}
.input-field {
    line-height: 150%!important;
    height: 43px!important;
    border: 1px solid #e0eaf9!important;
    width: 100%!important;
    padding: 6px 12px!important;
    font-size: 14px!important;
    font-weight: 400!important;
    font-family: inherit!important;
    background-color: #ffffff!important;
}
.property-label{
    font-size: 14px!important;
    color: #000!important;
    font-family: inherit!important;
    margin: 0!important;
    line-height: normal!important;
    padding: 0 !important;
    z-index: auto!important;
}

/* UI accordion */
.accordion-setting .setting-title {
    background-color: #fff;
    border: none;
    color: #000;
    font-weight: 500;
    font-size: 16px;
    padding: 0 20.8px 22.4px;
    margin-top: 0px;
}
.accordion-setting .setting-title:after {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    right: 19px;
    width: 16px;
    height: 16px;
}
.accordion-setting .ui-accordion-header-icon {
    display: none;
}
.custom-accordion .setting-panel {
    border: none;
    padding: 0px 20.8px 0px;
    overflow: visible;
}
.ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button:not([class*='APO-customSelect']) { 
    font-family: var(--Poppins-family);
}

.booking-toggle {
    border: none;
    padding: 2px 10px!important;
    width: 100%;
    /* max-width: 160px; */
    text-align: center;
    cursor: pointer;
	z-index: 1001;
	transition: opacity 0.5s ease-in-out;
    font-family: var(--Poppins-family)!important;
}
.booking-toggle.hidden {
    opacity: 0;
    pointer-events: none;
}
.booking-toggle.btnposition__left {
    left: 24px;
    bottom: 24px;
}
.booking-toggle.btnposition__right {
    right: 24px;
    bottom: 24px;
}
.booking-toggle.btnposition__center, .APO-booking .bookingBox--wrapper.btnposition__center {
    top: 50%;
    transform: translateY(-50%);
    bottom: auto;
}
.booking-toggle.btnposition__center {
    right: 0px;
    border-start-start-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    margin-right: 0;
    text-orientation: mixed;
    writing-mode: vertical-rl;
    /* width: 61px; */
    padding: 30px 5px 30px 10px;
}
.APO-booking .bookingBox--wrapper{
    background-color: #fff;
	/* border: 1px solid #e5e6eb; */
	bottom: 24px;
	height: calc(100% - 24px - 24px);
    min-height: 250px;
    max-height: 700px;
	width: 365px;
	z-index: 1001;
	overflow: hidden;
	transition: right 0.5s ease-in-out;
    box-shadow: 0 6px 6px 0 rgba(0, 0, 0, .02), 0 8px 24px 0 rgba(0, 0, 0, .12) !important;
}
.APO__back {
	cursor: pointer;
    color: #fff!important;
}

/* Quantity field */
.quantityField-wapper .btn-sub, .quantityField-wapper .btn-plus{
    background-color: #f7f7f7 !important;
    padding: 0 !important;
    cursor: pointer !important;
    min-width: 30px !important;
    border-color: #e0eaf9 !important;
    border-style: solid !important;

}
.quantityField-wapper .btn-sub{
    border-width: 1px 0px 1px 1px !important;
    border-radius: 12px 0px 0px 12px !important;
}
.quantityField-wapper .btn-plus{
    border-width: 1px 1px 1px 0px !important;
    border-radius: 0px 12px 12px 0px !important;
}

/* Add Guests Email style*/
.APO-guestsEmail-wrapper {
    height: 100% !important;
}
.APO-guestsEmail-wrapper .input-field {
    overflow-x: hidden!important;;
    height: auto !important;
    width: auto!important;;
    min-width: 30px!important;;
    min-height: 22px!important;;
    padding: 8px 0!important;;
    background-color: transparent!important;
    border: none!important;;
    outline: 0!important;;
}
.APO-guestsEmail-wrapper .APO-guest-valid-email {
    background-color: #9ac5ef!important;
}

/* show hide service box slide */
.APO-booking .bookingBox--wrapper.hide.btnposition__right, .APO-booking .bookingBox--wrapper.hide.btnposition__center {
	right: -100%;
}
.APO-booking .bookingBox--wrapper.show.btnposition__right, .APO-booking .bookingBox--wrapper.show.btnposition__center {
    right: 24px;
}
.APO-booking .bookingBox--wrapper.hide.btnposition__left {
	left: -100%;
}
.APO-booking .bookingBox--wrapper.show.btnposition__left {
    left: 24px;
}
.booking__Head {
    background-color: #1e75ff;
}
.booking__Head .bookingBox__title:first-letter { 
    text-transform: capitalize!important;
}
.booking__Head .bookingBox__title {
    color: #fff;
    font-weight: 500!important;
}
.APO-closeSlide {
    /* background-color: var(--gray-100);
    color: var(--gray-300); */
    background-color: #fff;
    color: #1e75ff;
    min-width: 20px;
}
.APO__Confirmwrapper .APO-closeSlide {
    background-color: #f1f5f9;
    color: #000;
}
.bookingBox__ {
    position: relative;
    max-height: 100%;
    height: 100%;
}
/* .APO__content {
    overflow-y: auto;
    /* max-height: 500px;
} */
/* .APO__content::-webkit-scrollbar {
    display: none;
} */
.APO__footerEnable {
    padding-bottom: 32px;
}
.APO__footer {
    color: rgb(146, 169, 193);
    position: absolute;
    bottom: 0px;
    background: #fff;
    left: 0;
    right: 0;
    padding: 4.8px 11.2px;
    z-index: 10;
    box-shadow: 0px 4px 12px 3px rgba(39, 45, 61, 0.1),    0px 2px 12px 3px rgba(39, 45, 61, 0.06);
}

@media (max-width:460px){
    .APO-booking .bookingBox--wrapper.show.btnposition__right, .APO-booking .bookingBox--wrapper.show.btnposition__center {
        right:15px;
    }
    .APO-booking .bookingBox--wrapper{
        width: 100%;
        max-width: 345px;
    }
    .booking-toggle.btnposition__right {
        right:15px;
    }
    .booking-toggle.btnposition__left {
        left: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./css/style.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,+BAA+B;AACnC;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;;AAErB;AACA;IACI,cAAc;AAClB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,qBAAqB;IACrB,+BAA+B;IAC/B,6BAA6B;IAC7B,0BAA0B;IAC1B,8BAA8B;IAC9B,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,gCAAgC;IAChC,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,sCAAsC;IACtC,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,sCAAsC;IACtC,wBAAwB;IACxB,SAAS;AACb;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;IAC3B,iCAAiC;IACjC,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,qCAAqC;AACzC;AACA;IACI,aAAa;AACjB;AACA;IACI,uCAAuC;IACvC,qCAAqC;AACzC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,qBAAqB;AACzB;AACA;;;GAGG;;AAEH,gCAAgC;AAChC;;EAEE,kCAAkC;EAClC,mBAAmB;AACrB;;CAEC,YAAY;AACb;IACI,uCAAuC;IACvC,oCAAoC;IACpC,+BAA+B;AACnC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,mCAAmC;IACnC,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,8BAA8B;IAC9B,mCAAmC;AACvC;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,WAAW;IACX,yDAAuD;IACvD,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;CAClB,aAAa;CACb,oCAAoC;IACjC,4CAA4C;AAChD;AACA;IACI,UAAU;IACV,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,QAAQ;IACR,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,UAAU;IACV,yCAAyC;IACzC,0CAA0C;IAC1C,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,sBAAsB;CACzB,+BAA+B;CAC/B,YAAY;CACZ,gCAAgC;IAC7B,iBAAiB;IACjB,iBAAiB;CACpB,YAAY;CACZ,aAAa;CACb,gBAAgB;CAChB,kCAAkC;IAC/B,sFAAsF;AAC1F;AACA;CACC,eAAe;IACZ,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,oCAAoC;IACpC,qBAAqB;IACrB,0BAA0B;IAC1B,0BAA0B;IAC1B,gCAAgC;IAChC,8BAA8B;;AAElC;AACA;IACI,wCAAwC;IACxC,2CAA2C;AAC/C;AACA;IACI,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA,0BAA0B;AAC1B;IACI,uBAAuB;AAC3B;AACA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;IACxB,uCAAuC;IACvC,sBAAsB;IACtB,oBAAoB;AACxB;AACA;IACI,mCAAmC;AACvC;;AAEA,gCAAgC;AAChC;CACC,YAAY;AACb;AACA;IACI,WAAW;AACf;AACA;CACC,WAAW;AACZ;AACA;IACI,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI;6BACyB;IACzB,sBAAsB;IACtB,cAAc;IACd,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;AACA;;;GAGG;AACH;;GAEG;AACH;IACI,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,WAAW;IACX,8FAA8F;AAClG;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":["/* Common element style */\r\n.APO-booking a:hover{\r\n    text-decoration: none!important;\r\n}\r\n.APO-booking .svg-inline--fa {\r\n    display: inline-block;\r\n    height: 1em;\r\n    overflow: visible;\r\n\r\n}\r\n.silver__font {\r\n    color: #717b81;\r\n}\r\n.APO-customSelect {\r\n    position: relative!important;\r\n}\r\n.APO-customSelect .APO-customSelect__input {\r\n    border-color: #e0eaf9 !important;\r\n    height: 36px !important;\r\n    margin-top: 0!important;\r\n    position: relative!important;\r\n    z-index: 10!important;\r\n    padding: 0 0.75rem!important;\r\n    font-size: 1rem!important;\r\n    color: #212121!important;\r\n    display: block!important;\r\n    width: 100%!important;\r\n    border-width: 0 0 1px!important;\r\n    border-style: solid!important;\r\n    border-radius: 0!important;\r\n    font-family: inherit!important;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    outline: none!important;\r\n}\r\n\r\n.APO-customSelect .APO-customSelect__dropdown {\r\n    overflow-y: auto!important;\r\n    max-height: 180px!important;\r\n    border-color: #e0eaf9 !important;\r\n    z-index: 10!important;\r\n    top: calc(100% - 1px);\r\n    background-color: #fff;\r\n    border-width: 1px!important;\r\n    border-style: solid!important;\r\n    border-radius: 0 0 12px 12px!important;\r\n    position: absolute;\r\n    width: 100%;\r\n    left: 0;\r\n}\r\n.APO-customSelect--dropup .APO-customSelect__dropdown {\r\n    border-radius: 12px 12px 0 0!important;\r\n    bottom: calc(100% - 1px);\r\n    top: auto;\r\n}\r\n.APO-customSelect .APO-customSelect__option-wrap .APO-customSelect__option {\r\n    border: none!important;\r\n}\r\n.APO-customSelect .APO-customSelect__option-wrap {\r\n    overflow-y: auto!important;\r\n    max-height: 180px!important;\r\n    position: relative!important;\r\n}\r\n.APO-customSelect .APO-customSelect__option {\r\n    font-family: inherit !important;\r\n    font-size: 14px !important;\r\n    font-weight: 400 !important;\r\n    height: 43px !important;\r\n    border-radius: 12px !important;\r\n    padding: 6px 12px !important;\r\n    color: #212121 !important;\r\n    line-height: 1.5 !important;\r\n    background-color: #fff !important;\r\n    border: 1px solid #e0eaf9 !important;\r\n    position: relative;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n    display: block;\r\n    width: 100%;\r\n    white-space: nowrap;\r\n    text-align: left;\r\n    text-overflow: ellipsis;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n}\r\n.APO-customSelect--active .APO-customSelect__option--value {\r\n    border-radius: 12px 0 0px 0px !important;\r\n}\r\n.APO-customSelect--dropup.APO-customSelect--active .APO-customSelect__option--value {\r\n    border-radius: 0 0 0px 12px!important;\r\n}\r\n.APO-customSelect .APO-customSelect__dropdown::-webkit-scrollbar, .APO-customSelect .APO-customSelect__dropdown .APO-customSelect__option-wrap::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n.APO-booking .APO-rounded-e-none .APO-customSelect .APO-customSelect__option {\r\n    border-start-end-radius: 0px !important;\r\n    border-end-end-radius: 0px !important;\r\n}\r\n.APO-booking .APO-border-r-0 .APO-customSelect .APO-customSelect__option {\r\n    border-right-width: 0px!important;\r\n}\r\n.inputGroup .APO-customSelect .APO-customSelect__option { \r\n    width: 80px!important;\r\n}\r\n/* .APO-customSelect__option-wrap .APO-customSelect__option {\r\n    padding: 6px 12px !important;\r\n    border: none !important;\r\n} */\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput.input-field::-webkit-outer-spin-button,\r\ninput.input-field::-webkit-inner-spin-button {\r\n  -webkit-appearance: none!important;\r\n  margin: 0!important;\r\n}\r\n\r\n /* Firefox */\r\ninput[type=\"number\"].input-field{\r\n    -webkit-appearance: textfield!important;\r\n    -moz-appearance: textfield!important;\r\n    appearance: textfield!important;\r\n}\r\n.input-field:focus-visible {\r\n    outline: none!important;\r\n}\r\n.has-error, .no-data {\r\n    color: #dc3545 !important;\r\n}\r\n.input-field {\r\n    line-height: 150%!important;\r\n    height: 43px!important;\r\n    border: 1px solid #e0eaf9!important;\r\n    width: 100%!important;\r\n    padding: 6px 12px!important;\r\n    font-size: 14px!important;\r\n    font-weight: 400!important;\r\n    font-family: inherit!important;\r\n    background-color: #ffffff!important;\r\n}\r\n.property-label{\r\n    font-size: 14px!important;\r\n    color: #000!important;\r\n    font-family: inherit!important;\r\n    margin: 0!important;\r\n    line-height: normal!important;\r\n    padding: 0 !important;\r\n    z-index: auto!important;\r\n}\r\n\r\n/* UI accordion */\r\n.accordion-setting .setting-title {\r\n    background-color: #fff;\r\n    border: none;\r\n    color: #000;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    padding: 0 20.8px 22.4px;\r\n    margin-top: 0px;\r\n}\r\n.accordion-setting .setting-title:after {\r\n    content: \"\";\r\n    background-image: url(../images/chevron-down-solid.svg);\r\n    position: absolute;\r\n    right: 19px;\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n.accordion-setting .ui-accordion-header-icon {\r\n    display: none;\r\n}\r\n.custom-accordion .setting-panel {\r\n    border: none;\r\n    padding: 0px 20.8px 0px;\r\n    overflow: visible;\r\n}\r\n.ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button:not([class*='APO-customSelect']) { \r\n    font-family: var(--Poppins-family);\r\n}\r\n\r\n.booking-toggle {\r\n    border: none;\r\n    padding: 2px 10px!important;\r\n    width: 100%;\r\n    /* max-width: 160px; */\r\n    text-align: center;\r\n    cursor: pointer;\r\n\tz-index: 1001;\r\n\ttransition: opacity 0.5s ease-in-out;\r\n    font-family: var(--Poppins-family)!important;\r\n}\r\n.booking-toggle.hidden {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n.booking-toggle.btnposition__left {\r\n    left: 24px;\r\n    bottom: 24px;\r\n}\r\n.booking-toggle.btnposition__right {\r\n    right: 24px;\r\n    bottom: 24px;\r\n}\r\n.booking-toggle.btnposition__center, .APO-booking .bookingBox--wrapper.btnposition__center {\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    bottom: auto;\r\n}\r\n.booking-toggle.btnposition__center {\r\n    right: 0px;\r\n    border-start-start-radius: 0px !important;\r\n    border-bottom-right-radius: 0px !important;\r\n    margin-right: 0;\r\n    text-orientation: mixed;\r\n    writing-mode: vertical-rl;\r\n    /* width: 61px; */\r\n    padding: 30px 5px 30px 10px;\r\n}\r\n.APO-booking .bookingBox--wrapper{\r\n    background-color: #fff;\r\n\t/* border: 1px solid #e5e6eb; */\r\n\tbottom: 24px;\r\n\theight: calc(100% - 24px - 24px);\r\n    min-height: 250px;\r\n    max-height: 700px;\r\n\twidth: 365px;\r\n\tz-index: 1001;\r\n\toverflow: hidden;\r\n\ttransition: right 0.5s ease-in-out;\r\n    box-shadow: 0 6px 6px 0 rgba(0, 0, 0, .02), 0 8px 24px 0 rgba(0, 0, 0, .12) !important;\r\n}\r\n.APO__back {\r\n\tcursor: pointer;\r\n    color: #fff!important;\r\n}\r\n\r\n/* Quantity field */\r\n.quantityField-wapper .btn-sub, .quantityField-wapper .btn-plus{\r\n    background-color: #f7f7f7 !important;\r\n    padding: 0 !important;\r\n    cursor: pointer !important;\r\n    min-width: 30px !important;\r\n    border-color: #e0eaf9 !important;\r\n    border-style: solid !important;\r\n\r\n}\r\n.quantityField-wapper .btn-sub{\r\n    border-width: 1px 0px 1px 1px !important;\r\n    border-radius: 12px 0px 0px 12px !important;\r\n}\r\n.quantityField-wapper .btn-plus{\r\n    border-width: 1px 1px 1px 0px !important;\r\n    border-radius: 0px 12px 12px 0px !important;\r\n}\r\n\r\n/* Add Guests Email style*/\r\n.APO-guestsEmail-wrapper {\r\n    height: 100% !important;\r\n}\r\n.APO-guestsEmail-wrapper .input-field {\r\n    overflow-x: hidden!important;;\r\n    height: auto !important;\r\n    width: auto!important;;\r\n    min-width: 30px!important;;\r\n    min-height: 22px!important;;\r\n    padding: 8px 0!important;;\r\n    background-color: transparent!important;\r\n    border: none!important;;\r\n    outline: 0!important;;\r\n}\r\n.APO-guestsEmail-wrapper .APO-guest-valid-email {\r\n    background-color: #9ac5ef!important;\r\n}\r\n\r\n/* show hide service box slide */\r\n.APO-booking .bookingBox--wrapper.hide.btnposition__right, .APO-booking .bookingBox--wrapper.hide.btnposition__center {\r\n\tright: -100%;\r\n}\r\n.APO-booking .bookingBox--wrapper.show.btnposition__right, .APO-booking .bookingBox--wrapper.show.btnposition__center {\r\n    right: 24px;\r\n}\r\n.APO-booking .bookingBox--wrapper.hide.btnposition__left {\r\n\tleft: -100%;\r\n}\r\n.APO-booking .bookingBox--wrapper.show.btnposition__left {\r\n    left: 24px;\r\n}\r\n.booking__Head {\r\n    background-color: #1e75ff;\r\n}\r\n.booking__Head .bookingBox__title:first-letter { \r\n    text-transform: capitalize!important;\r\n}\r\n.booking__Head .bookingBox__title {\r\n    color: #fff;\r\n    font-weight: 500!important;\r\n}\r\n.APO-closeSlide {\r\n    /* background-color: var(--gray-100);\r\n    color: var(--gray-300); */\r\n    background-color: #fff;\r\n    color: #1e75ff;\r\n    min-width: 20px;\r\n}\r\n.APO__Confirmwrapper .APO-closeSlide {\r\n    background-color: #f1f5f9;\r\n    color: #000;\r\n}\r\n.bookingBox__ {\r\n    position: relative;\r\n    max-height: 100%;\r\n    height: 100%;\r\n}\r\n/* .APO__content {\r\n    overflow-y: auto;\r\n    /* max-height: 500px;\r\n} */\r\n/* .APO__content::-webkit-scrollbar {\r\n    display: none;\r\n} */\r\n.APO__footerEnable {\r\n    padding-bottom: 32px;\r\n}\r\n.APO__footer {\r\n    color: rgb(146, 169, 193);\r\n    position: absolute;\r\n    bottom: 0px;\r\n    background: #fff;\r\n    left: 0;\r\n    right: 0;\r\n    padding: 4.8px 11.2px;\r\n    z-index: 10;\r\n    box-shadow: 0px 4px 12px 3px rgba(39, 45, 61, 0.1),    0px 2px 12px 3px rgba(39, 45, 61, 0.06);\r\n}\r\n\r\n@media (max-width:460px){\r\n    .APO-booking .bookingBox--wrapper.show.btnposition__right, .APO-booking .bookingBox--wrapper.show.btnposition__center {\r\n        right:15px;\r\n    }\r\n    .APO-booking .bookingBox--wrapper{\r\n        width: 100%;\r\n        max-width: 345px;\r\n    }\r\n    .booking-toggle.btnposition__right {\r\n        right:15px;\r\n    }\r\n    .booking-toggle.btnposition__left {\r\n        left: 15px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
